import { apiClient, API } from "@/lib/api";
import { toast } from "sonner";

export async function uploadFile(file) {
  if (!file) return null;
  const form = new FormData();
  form.append("file", file);
  try {
    const { data } = await apiClient.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
    return data; // { storage_path, original_filename, size, content_type }
  } catch (e) {
    toast.error(e.response?.data?.detail || "Gagal upload file");
    return null;
  }
}

export async function downloadFile(storagePath, suggestedName) {
  const token = localStorage.getItem("fodm_token");
  try {
    const res = await fetch(`${API}/files/${storagePath}`, { headers: { Authorization: `Bearer ${token}` } });
    if (!res.ok) throw new Error("Gagal");
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = suggestedName || "file"; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (e) {
    toast.error("Gagal mengunduh file");
  }
}

export function viewFileUrl(storagePath) {
  const token = localStorage.getItem("fodm_token");
  return `${API}/files/${storagePath}?auth=${encodeURIComponent(token || "")}`;
}

// Alias used by preview modal — always respects auth
export function previewUrl(storagePath) { return viewFileUrl(storagePath); }
